import type { PaymentMethod } from "../../domain/entities/PaymentMethod";
import type { CountryCode } from "../../domain/value-objects/CountryCode";
import type { PaymentMethodQueryPort } from "../ports/PaymentMethodQueryPort";

export class GetPaymentMethodsByCountryUseCase {
  constructor(private readonly paymentMethodQueryPort: PaymentMethodQueryPort) {}

  async execute(countryCode: CountryCode): Promise<PaymentMethod[]> {
    return this.paymentMethodQueryPort.listByCountry(countryCode);
  }
}
